var productBundlePacks = window.productBundlePacks || 3;


(function () {
  $(document).ready(function () {
    // GLOBAL VARIABLE
    const productItem = $(".lp-bundle__sticker-item");
    const bundle = $(".selected-bundle-container-ds .selected-bundle-ds");
   


    let productArray = JSON.parse(localStorage.getItem("isSelectedItem")) || [];
    let selectedContent =
      JSON.parse(localStorage.getItem("isActiveItem")) || [];

    if (selectedContent.length === 0) {
      productItem.each((_, val) => {
        val.setAttribute("data-product-quantity", 0);
      });
      $(".bundle-quantity").each((_, val) => {
        val.setAttribute("value", 0);
      });
    }

    if(productArray.length > productBundlePacks){
      $(".selected-items__counter").text(`Please remove ${Math.abs(productBundlePacks - productArray.length)} packs`);
    }else {
      $(".selected-items__counter").text(`Pick ${productBundlePacks - productArray.length} more Packs`);

    }


    productItem.each(function (_, val) {
      selectedContent?.forEach((data) => {
        if (val.getAttribute("data-product-id") === data.product_id) {
          val.setAttribute(
            "data-product-selected",
            data.product_properties.product_selected
          );
          val.setAttribute(
            "data-product-quantity",
            data.product_properties.product_quantity
          );
          val
            .querySelector(".bundle-quantity-container .bundle-quantity")
            .setAttribute("value", data.product_properties.product_quantity);
        }
      });
    });

    // Add Initial Image
    for (let i = bundle.length - 1; i >= 0; i--) {
      if (i < productArray?.length) {
        $(bundle[i]).children("img").attr("src", productArray[i].product_img);
        $(bundle[i]).children("img").addClass("active");
        $(bundle[i]).attr("data-selected-id", productArray[i].product_id);
        $(bundle[i]).children("button").css("display", "block");
      } else {
        $(bundle[i])
          .children("img")
          .attr("src", "//www.natpat.com/cdn/shop/files/lp-bundle-builder-empty-box.png?v=5829916032801006942");
        $(bundle[i]).attr("data-selected-id", "");
      }
    }

    // function addData(){
    //     let variantID = '';
    //       let variantQuantity = '';
    //       selectedContent.forEach(data => {
    //         variantID += `${data.product_id},`
    //         variantQuantity += `${data.product_properties.product_quantity},`
    //       })

    //       $('.btn-cart-all').attr('data-variant-id', variantID)
    //       $('.btn-cart-all').attr('data-variant-quantity', variantQuantity)
    //   }
    //   addData()

    function addData(){
          let dataUrl = '/cart/';
          selectedContent.forEach(data => {
            dataUrl += `${data.product_id}:${data.product_properties.product_quantity},`
          })

          const url = dataUrl.slice(0, dataUrl.length - 1)
        const discountCode = $('.btn-cart-all').data('discount-code'); 
        const freeGiftItem = $('.btn-cart-all').data('free-gift'); 
        const discountURL = '?discount=' + discountCode;
        let freeGiftItemURL = ''; 
        if (freeGiftItem) { 
           freeGiftItemURL = ',' + freeGiftItem + ':1';
        } 
        const urlDiscountParam =  url + freeGiftItemURL + discountURL
        
            $('.btn-cart-all').attr('href', url)
          $('.btn-cart-all').attr('href', urlDiscountParam)

      }
      addData()


    function disabledBtn() {
      const btn = $(".lp-bundle__sticker-item .sticker-item__cart");
      if (productArray.length === productBundlePacks) {
        btn.attr("disabled", true);
        btn.css("opacity", ".4");
        $(".btn-cart-all").css("display", "block");
        $(".selected-items__counter").css("display", "none");
        $('.packs__active.pack-btn .selected-items__price').show();
      } else {
        btn.attr("disabled", false);
        btn.css("opacity", "1");
        $('.packs__active.pack-btn .selected-items__price').hide();

      }
    }
    disabledBtn();

    function addImage() {
       const bundle = $(".selected-bundle-container-ds .selected-bundle-ds");
      for (let i = bundle.length - 1; i >= 0; i--) {
        if (i < productArray.length) {
          $(bundle[i]).children("img").attr("src", productArray[i].product_img);
          $(bundle[i]).children("img").addClass("active");
          $(bundle[i]).attr("data-selected-id", productArray[i].product_id);
          $(bundle[i]).children("button").css("display", "block");
        } else {
          $(bundle[i])
            .children("img")
            .attr("src", "//www.natpat.com/cdn/shop/files/lp-bundle-builder-empty-box.png?v=5829916032801006942");
          $(bundle[i]).children("img").removeClass("active");
          $(bundle[i]).attr("data-selected-id", "");
          $(bundle[i]).children("button").css("display", "none");
        }
      }
    }

    productItem.click(function (e) {
      // return false if not targeted Btn
      if (!e.target) {
        return;
      }

      const targetedProduct = e.target;
      const targetedClass = targetedProduct.getAttribute("class");
      const selectedProduct = targetedProduct.closest(
        ".lp-bundle__sticker-item"
      );
      const productImg = selectedProduct
        .querySelector(".sticker-item_img")
        .getAttribute("src");
      const productId = selectedProduct.getAttribute("data-product-id");

      function addProduct() {
        productArray.push({
          product_img: productImg,
          product_id: productId,
        });

        localStorage.setItem("isSelectedItem", JSON.stringify(productArray));
      }

      // Add Cart
      if (
        targetedClass === "sticker-item__cart" &&
        productArray.length < productBundlePacks
      ) {
        addProduct();
        addImage();
        disabledBtn();

        selectedProduct.setAttribute("data-product-selected", true);
        selectedProduct.setAttribute("data-product-quantity", 1);
        selectedProduct
          .querySelector(".bundle-quantity")
          .setAttribute("value", 1);
        selectedContent.push({
          product_id: productId,
          product_properties: {
            product_quantity: selectedProduct.getAttribute(
              "data-product-quantity"
            ),
            product_selected: selectedProduct.getAttribute(
              "data-product-selected"
            ),
          },
        });
        localStorage.setItem("isActiveItem", JSON.stringify(selectedContent));
        $(".selected-items__counter").text(`Pick ${productBundlePacks - productArray.length} more Packs`);
        addData()
      }

      const latestQuantity = selectedProduct.getAttribute(
        "data-product-quantity"
      );
      const productID = selectedProduct.getAttribute("data-product-id");
      let quantity = +latestQuantity;

      // Add Quantity
      if (
        targetedClass === "bundle-increase-quantity" &&
        productArray.length < productBundlePacks
      ) {
        quantity++;

        selectedProduct.setAttribute("data-product-quantity", quantity);
        const updatedQuantity = selectedProduct.getAttribute(
          "data-product-quantity"
        );
        selectedProduct
          .querySelector(".bundle-quantity")
          .setAttribute("value", updatedQuantity);
        addProduct();
        addImage();

        // update Quantity
        selectedContent.forEach((data) => {
          if (data.product_id === productID) {
            data.product_properties.product_quantity = updatedQuantity;
          }
        });

        localStorage.setItem("isActiveItem", JSON.stringify(selectedContent));
        disabledBtn();
        $(".selected-items__counter").text(`Pick ${productBundlePacks - productArray.length} more Packs`);
        addData()
      }

      if (
        targetedClass === "bundle-decrease-quantity" &&
        productArray.length > 0
      ) {
        if (quantity > 1) {
          quantity--;
        } else {
          quantity = 0;
        }

        selectedProduct.setAttribute("data-product-quantity", quantity);
        const updatedQuantity = selectedProduct.getAttribute(
          "data-product-quantity"
        );
        selectedProduct
          .querySelector(".bundle-quantity")
          .setAttribute("value", updatedQuantity);

        // Remove Product
        const filteredProduct = productArray.filter((data) => {
          return data.product_id === productID;
        });
        filteredProduct.pop();
        const otherProduct = productArray.filter((data) => {
          return data.product_id !== productID;
        });
        productArray = [...filteredProduct, ...otherProduct];
        localStorage.setItem("isSelectedItem", JSON.stringify(productArray));
        addImage();

        // update Quantity
        const remove = selectedContent.filter((data) => {
          if (data.product_id === productID) {
            data.product_properties.product_quantity = updatedQuantity;
            if (quantity === 0) {
              data.product_properties.product_selected = false;
            }
          }
          return data.product_properties.product_quantity !== "0";
        });

        selectedContent = remove;
        if (quantity === 0) {
          selectedProduct.setAttribute("data-product-selected", false);
        }

        localStorage.setItem("isActiveItem", JSON.stringify(selectedContent));
        disabledBtn();
        $(".btn-cart-all").css("display", "none");
        $(".selected-items__counter").css("display", "block");

        if(productArray.length > productBundlePacks){
          $(".selected-items__counter").text(`Please remove ${Math.abs(productBundlePacks - productArray.length)} Packs`);
        }else if(productArray.length == productBundlePacks){
          $(".btn-cart-all").css("display", "block");
          $(".selected-items__counter").css("display", "none");
        }else if (productArray.length < productBundlePacks){
          $(".selected-items__counter").text(`Pick ${productBundlePacks - productArray.length} more Packs`);
        }
        addData()
      }
    });

    $(".selected-bundle-ds .remove-pack-item").click(function (e) {
      const targetBtn = $(this);
      const targetBtnParentEl = targetBtn.closest(".selected-bundle-container-ds .selected-bundle-ds");
      const selectedID = targetBtnParentEl.attr("data-selected-id");

      // Remove Product
      const filteredProduct = productArray.filter((data) => {
        return data.product_id === selectedID;
      });
      filteredProduct.pop();
      const otherProduct = productArray.filter((data) => {
        return data.product_id !== selectedID;
      });

      productArray = [...filteredProduct, ...otherProduct];
      localStorage.setItem("isSelectedItem", JSON.stringify(productArray));
      addImage();

      const activeItem = $(".lp-bundle__sticker-item");
      activeItem.each(function (_, val) {
        if (val.getAttribute("data-product-id") === selectedID) {
          const latestQuantity = val.getAttribute("data-product-quantity");
          let quantity = +latestQuantity;
          if (quantity > 1) {
            quantity--;
          } else {
            quantity = 0;
          }

          val.setAttribute("data-product-quantity", quantity);
          const updatedQuantity = val.getAttribute("data-product-quantity");
          val
            .querySelector(".bundle-quantity")
            .setAttribute("value", updatedQuantity);

          const remove = selectedContent.filter((data) => {
            if (data.product_id === selectedID) {
              data.product_properties.product_quantity = updatedQuantity;
              if (quantity === 0) {
                data.product_properties.product_selected = false;
              }
            }
            return data.product_properties.product_quantity !== "0";
          });

          selectedContent = remove;
          if (quantity === 0) {
            val.setAttribute("data-product-selected", false);
          }
          localStorage.setItem("isActiveItem", JSON.stringify(selectedContent));
        }
      });
      disabledBtn();
      $(".btn-cart-all").css("display", "none");
      $(".selected-items__counter").css("display", "block");
      if(productArray.length > productBundlePacks){
        $(".selected-items__counter").text(`Please remove ${Math.abs(productBundlePacks - productArray.length)} Packs`);
      }else if(productArray.length == productBundlePacks){
        $(".btn-cart-all").css("display", "block");
        $(".selected-items__counter").css("display", "none");
      }else if (productArray.length < productBundlePacks){
        $(".selected-items__counter").text(`Pick ${productBundlePacks - productArray.length} more Packs`);
      }
      addData()
    });

    // $('.pack-btn').each(btn => {
    //    if(productBundlePacks !== 4){
    //     productBundlePacks = 4;
    //     $('.clone-bundle .selected-bundle-ds').slice(0, 1).clone().appendTo('.selected-bundle-container-ds');
    //     disabledBtn();
    //   }
    // })
    $('.packs-toggle__4-6-packs').on('click', '.pack-btn', function(){
      if(!$(this)){
        return
      }

      // Toggle Active
      $('.pack-btn').removeClass('packs__active')
      $('.pack-btn .selected-items__price').hide();
      $(this).addClass('packs__active')

      const beforePrice = $(this).attr('data-price-before')
      const afterPrice = $(this).attr('data-price-after')
      const percentOff = $(this).attr('data-percent-off')

      const bundleLength = $('.selected-bundle-container-ds .selected-bundle-ds').length
      if($(this).attr('data-pack-count') == 5 && productBundlePacks !== 5){
        productBundlePacks = 5;
        if(bundleLength === 3){
          for(let i = 0; i < 2; i++){
            $('.clone-bundle .selected-bundle-ds').clone(true, true).appendTo('.selected-bundle-container-ds');
          }
        }
        if(bundleLength === 7){
          $('.selected-bundle-container-ds .selected-bundle-ds').slice(-2).remove();
        }
      }
      if($(this).attr('data-pack-count') == 7 && productBundlePacks !== 7){
        productBundlePacks = 7;
         if(bundleLength === 3){
          for(let i = 0; i < 4; i++){
            $('.clone-bundle .selected-bundle-ds').clone(true, true).appendTo('.selected-bundle-container-ds');
          }
        }
        if(bundleLength === 5){
          for(let i = 0; i < 2; i++){
            $('.clone-bundle .selected-bundle-ds').clone(true, true).appendTo('.selected-bundle-container-ds');
          }
        }
      }
      if($(this).attr('data-pack-count') == 3 && productBundlePacks !== 3){
         productBundlePacks = 3;
        if(bundleLength === 5){
            $('.selected-bundle-container-ds .selected-bundle-ds').slice(-2).remove();
        }
        if(bundleLength === 7){
            $('.selected-bundle-container-ds .selected-bundle-ds').slice(-4).remove();
        }
      }

        if(productArray.length > productBundlePacks){
          $(".selected-items__counter").text(`Please remove ${Math.abs(productBundlePacks - productArray.length)} Packs`);
          $(".btn-cart-all").css("display", "none");
          $(".selected-items__counter").css("display", "block");
        }else if(productArray.length == productBundlePacks){
          $(".btn-cart-all").css("display", "block");
          $(".selected-items__counter").css("display", "none");
        }else if (productArray.length < productBundlePacks){
          $(".selected-items__counter").text(`Pick ${productBundlePacks - productArray.length} more Packs`);
          $(".btn-cart-all").css("display", "none");
          $(".selected-items__counter").css("display", "block");
        }
        $('.selected-items__price .price__before').text(beforePrice)
        $('.selected-items__price .price__after').text(afterPrice)
        $('.packs-toggle__percent-save span').text(percentOff)

        addImage()
        disabledBtn();
    })

  //   $(".btn-cart-all").click(async function(e) {
  //     e.preventDefault(); 
  //     const IDs = $(".btn-cart-all").attr('data-variant-id');
  //     const IDArr = IDs.split(',');
  //     const quantities = $(".btn-cart-all").attr('data-variant-quantity');
  //     const quantityArr = quantities.split(',');

  //     const variantIds = IDArr.filter(id => (typeof id === 'string' || typeof id === 'number') && id.trim() !== '');
  //     const variantQuantities = quantityArr.filter(quantity => (typeof quantity === 'string' || typeof quantity === 'number') && quantity.trim() !== '');

  //     try {
  //         for (let i = 0; i < variantIds.length; i++) {
  //             const variantId = variantIds[i];
  //             const variantQuantity = variantQuantities[i];
  //             await $.ajax({
  //                 type: "POST",
  //                 url: "/cart/add.js",
  //                 data: {
  //                     quantity: variantQuantity,
  //                     id: variantId
  //                 },
  //                 dataType: "json" 
  //             }); 
  //         } 
 
  //     } catch (error) {
  //         console.error("Error adding variant to cart:");
  //         console.error(error.responseText);
  //     }
       
  //     console.log("Variant added to cart successfully!");
  //          setTimeout(function () {
  //         window.location.href = "/checkout";
  //     }, 500);
 
  // });


    const removeTime = 10000;
    let timer;

    function resetTime() {
      clearTimeout(timer);
      timer = setTimeout(removeDataStorage, removeTime);
    }

    function removeDataStorage() {
      localStorage.removeItem("isActiveItem");
      localStorage.removeItem("isSelectedItem");
    }

    function handleUserActivity() {
      resetTime();
    }

    document.addEventListener("mousemove", handleUserActivity);
    document.addEventListener("scroll", handleUserActivity);
    resetTime();

    const reviewsTitle = document.createElement('h3');
    reviewsTitle.innerText = '4.85/5';
    reviewsTitle.classList.add('text-rate');

    setTimeout(()=> {
      $('.jdgm-rev-widg__summary-inner').before(reviewsTitle)
    }, 3000);

    $('#lp-bundle__free-shipping').insertBefore('.header-wrapper');
   
  });
})();
